import React from 'react';
import {hashHistory} from 'react-router';
import {RaisedButton, TextField, CircularProgress} from 'material-ui';
import {observable} from 'mobx';
import {inject, observer} from 'mobx-react';
import moment from 'moment';
import {postData} from '../libs/api';
import ReactNotify from 'react-notify';

@inject('unitStore')
@observer
class EntryTable extends React.Component {

  @observable parameters = null;
  @observable dataOrigin = null;
  @observable datetime = moment().format('YYYY-MM-DDTHH:mm:ss');
  @observable loading = false;

  componentWillMount() {
    const {dataOrigin, params:{dataSourceId}} = this.props;
    this.setOrigins(dataOrigin, dataSourceId);
  }

  componentWillReceiveProps(props) {
    const {dataOrigin, params:{dataSourceId}} = props;
    this.setOrigins(dataOrigin, dataSourceId);
  }

  setOrigins = (dataOrigin, dataSourceId) => {
    if (dataOrigin && dataOrigin.origins) {
      let origins = dataOrigin.origins.filter(x => +x.id === +dataSourceId)[0];
      if (origins) {
        this.dataOrigin = origins;
        this.format(dataOrigin.origins.filter(x => +x.id === +dataSourceId)[0].data_origin_parameters);
      } else {
        hashHistory.push('/');
      }
    } else {
      hashHistory.push('/');
    }
  };

  format = parameters => {
    this.parameters = parameters && parameters.map(par => ({
        id: par.code,
        name: par.parameter_name,
        value: null,
        unit: par.parameter_unit_id
      }));
  };

  onChangeValue = (e, value) => {
    // if (+e.target.value == e.target.value || parseFloat(e.target.value) == e.target.value) {
      // eslint-disable-next-line
      this.parameters.filter(par => par.id == e.target.id)[0].value = e.target.value;
    // }
    // else if (e.target.value === '')
      // eslint-disable-next-line
      // this.parameters.filter(par => par.id == e.target.id)[0].value = value;
    // console.log(e.target.id, this.parameters.filter(par => par.id == e.target.id)[0])
  };
  onChangeDate = (e) => this.datetime = e.target.value ? moment(e.target.value).format('YYYY-MM-DDTHH:mm:ss') : null;

  onSubmit = () => {
    if (!this.datetime) {
      this.refs.notificator.error("Enter date and time.", '', 4000);
      return null;
    }
    this.loading = true;
    let origin_code = this.dataOrigin.code;
    let payload = [];
    // eslint-disable-next-line array-callback-return
    this.parameters.map(par => {
      if (par.value) {
        payload.push({
          origin_code,
          parameter_code: par.id,
          time: moment(this.datetime).format('YYYY-MM-DDTHH:mm:ss'),
          value: par.value
        })
      }
    });
    if (payload.length === 0) {
      this.refs.notificator.error("Payload is empty.", '', 4000);
      this.loading = false;
      return null;
    }

    postData(payload).then(res => {
      console.log(res);
      this.loading = false;
      if(res.message && res.message.id){
        this.refs.notificator.error('Data not posted', '', 4000);
      }else{
        this.datetime = null;
        this.parameters.map(item => {
          item.value = null;
        });
        this.refs.notificator.success("Data posted to TSS.", '', 4000);
      }
    }).catch(err => {
      console.log(err);
      this.loading = false;
      this.refs.notificator.error(err, 4000);
    });
  };


  render() {
    const getUnit = (id) => {
      let unit = this.props.unitStore.findById(id);
      return(`${unit.name} (${unit.symbol})`);
    };

    return (
      <div className="content-table">
        <ReactNotify ref="notificator"/>
        {this.loading && <div className="spinner"><CircularProgress/></div>}
        <div>
          {this.dataOrigin && this.dataOrigin.stations && <div><b>Deployed Stations
            : </b>{this.dataOrigin.stations.map((station, index) => (`${station.name}${index < this.dataOrigin.stations.length - 1 ? ', ' : ''}`))}
          </div>}
          <div style={{display: 'flex', flexDirection: 'row'}}><b style={{marginTop: '3px', marginRight: '10px'}}>Date
            : </b><input type="datetime-local" value={this.datetime} onChange={this.onChangeDate}/></div>
        </div>
        <table className="table" style={{padding: '10px'}}>
          <thead>
          <tr>
            <th>SN</th>
            <th>NAME</th>
            <th>VALUE</th>
            <th>UNIT</th>
          </tr>
          </thead>
          <tbody>
          {this.parameters &&
          this.parameters.sort((a, b) => a.name.toLowerCase() < b.name.toLowerCase() ? -1 : 1).map((dataSource, i) => (
            <tr key={i}>
              <td>{i + 1}</td>
              <td>{dataSource.name}</td>
              <td><TextField id={dataSource.id} type="text" underlineShow={false} style={{height: '30px'}}
                             inputStyle={{paddingLeft: '5px', height: '30px', border: '1px light-gray solid'}}
                             value={dataSource.value ? `${dataSource.value}` : ''} onChange={this.onChangeValue}/></td>
              <td>{getUnit(dataSource.unit)}</td>
            </tr>
          ))}
          </tbody>
        </table>
        <RaisedButton label='Submit' primary={true} onClick={this.onSubmit}/>
      </div>
    );
  }
}

export default EntryTable;


// WEBPACK FOOTER //
// ./src/components/EntryTable.js